module.exports = __webpack_public_path__ + "static/media/point+9.70fffaad.png";